module.exports = __webpack_public_path__ + "img/map-marker-stop.aecb818f.svg";